<script lang="ts" setup>
import { FormLabel, Formula } from '@pohlcon/design-system';
import { useI18n } from 'vue-i18n';
import type { Attribute } from '~/models';

const { t } = useI18n();

interface Props {
  attribute: Attribute;
}

const props = defineProps<Props>();

</script>

<template>
  <div class="attribute" v-if="attribute.toPrint">
    <FormLabel labelPosition="labelLeading">
      <template #label>
        {{ t(`printView.preview.attributes.${attribute.title}.title`) }}
        <Formula v-if="attribute.title === 'lambda'" latex="\lambda_{eq}" size="small" font="Verdana" />
      </template>
      <span :class="{ hide: !!attribute.className }" v-html="attribute.value" />
      <slot :value="attribute.value" />
      <img v-if="attribute.img" :src="attribute.img" alt="" />
    </FormLabel>
  </div>
</template>

<style lang="scss">
@use '../../variables' as *;

$img-size: 150px;

.attribute {
  margin: 0 0 var(--gutter-m) 0;
  display: grid;
  align-items: center;

  span {
    margin: auto 0;

    &.hide {
      display: none;
    }
  }

  // label.label {
  //   &[labelPosition="labelLeading"] {
  //     grid-template-columns: 2fr 3fr;
  //     align-items: center;

  //     @media screen and (max-width: $breakpoint-nav) {
  //       grid-template-columns: 1fr 1fr;
  //     }

  //     .label__text {
  //       grid-template-columns: auto 1fr;
  //       grid-gap: var(--gutter-2xs);
  //     }
  //   }
  // }

  img:not(.formula) {
    max-width: $img-size;
    object-fit: cover;
    mix-blend-mode: darken;
  }

  .appendix img.formula {
    margin-left: var(--gutter-xs);
  }

  @media screen and (max-width: $breakpoint-tablet) {
    grid-auto-flow: row;
    row-gap: 1rem;
  }
}

.category {
  font-size: 2rem;

  .appendix {
    font-size: initial;
    font-weight: initial;
  }
}
</style>
